const problems = [
  {
    icon: "ri-time-line",
    title: "The clock runs out 2 August 2026",
    desc: "Article 50 enforcement is fixed. The only variable is whether your products are compliant when the deadline hits.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "An audit-grade evidence gap",
    desc: "A disclosure text is not enough. Auditors want clause-by-clause findings and model-layer evidence your team can re-run.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Data must stay in your perimeter",
    desc: "Sending prompts, model outputs, or customer traffic to a third-party compliance SaaS is a non-starter for regulated teams.",
  },
];

export default function Problem() {
  return (
    <section id="problem" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-error-warning-line" />
            Why teams scramble
          </p>
          <h2 className="section-title">
            Article 50 sounds small. The evidence gap is not.
          </h2>
          <p className="section-lede">
            The transparency obligation looks like a paragraph. In practice, it forces every AI feature to ship with machine-checkable evidence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {problems.map((item) => (
            <div key={item.title} className="card hover:border-primary-300/60 transition-colors duration-300">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}